var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.327 1.73 2.439.617a2 2 0 0 1 2.829 0l1.886 1.886a2 2 0 0 1 0 2.828L5.832 6.653c.669 1.57 1.945 2.817 3.526 3.545l1.331-1.331a2 2 0 0 1 2.829 0l1.885 1.885a2 2 0 0 1 0 2.829l-1.045 1.045a4.58 4.58 0 0 1-4.302 1.218l-.182-.043A13.1 13.1 0 0 1 .116 5.869a4.49 4.49 0 0 1 1.21-4.139m2.055-.17L2.27 2.673a3.16 3.16 0 0 0-.852 2.91 11.76 11.76 0 0 0 8.765 8.92l.182.044a3.25 3.25 0 0 0 3.05-.864l1.045-1.045a.667.667 0 0 0 0-.943L12.575 9.81a.667.667 0 0 0-.943 0l-1.65 1.65a.67.67 0 0 1-.723.146l-.093-.038c-2.133-.87-3.89-2.547-4.7-4.742a.84.84 0 0 1 .194-.887l1.55-1.55a.667.667 0 0 0 0-.943L4.326 1.56a.667.667 0 0 0-.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;